<template>
    <div>
        <v-table    ref="table"
                    :fields="fields"
                    :items-provider="provider"
                    search
                    :row-class="item=>item.TMSAmount != item.BankAmount ? 'bg-light-danger' : null"
                    pagination="server">
                        <template #additional-actions>
                            <div class="row align-items-center">
                                <div class="col-md-5">
                                    <select class="form-control" v-model="bank">
                                        <option :value="null">Tümü</option>
                                        <option :value="true">Dosyada Var</option>
                                        <option :value="false">Dosyada Yok</option>
                                    </select>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-success" v-on:click="refresh">Sorgula</button>
                                    <v-executer variant="secondary" class="ml-50" v-if="sterling.Sync == false" :action="createFile" :loading="fileCreating">Dosya Oluştur</v-executer>
                                </div>
                            </div>
                        </template>
        </v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'

// Arabuluculuk ödeme gönderiminin "Personel Kontrol" ekranı — salt görüntüleme.
// KYKM/Maaş'taki tekil tutar-düzenle / personel-çıkar işlemleri arabuluculukta yok;
// bir ödemeyi çıkarmak için arabuluculuk adımından silinir.
export default {
    props:{
        sterling:Object,
        tableRefresh:Function
    },
    data(){
        return{
            fields:[
                {name:'Personel',key:'FullName',tdClass:'text-nowrap'},
                {name:'Kimlik Numarası',key:'IdentityNumber'},
                {name:'IBAN',key:'IBAN'},
                {name:'TMS Tutarı',key:'TMSAmount'},
                {name:'Dosya Tutarı',key:'BankAmount'},
                {name:'Dosyada Var',key:'Bank',thClass:'text-nowrap'},
            ],
            bank:null,
            fileCreating:false
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyListBySterling({
                SterlingId: this.sterling.Id,
                Bank: this.bank,
                ...data
            })
        },
        refresh(){
            this.$refs.table.refresh()
        },
        createFile(){
            this.fileCreating = true
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyGenerate(this.sterling.Id).then(res=>{
                this.fileCreating = false
                this.$result(res)
                if(res.data.Success){
                    this.tableRefresh()
                }
            }).catch(err => {
                this.fileCreating = false
                this.$result(null,err)
            })
        }
    }
}
</script>
